// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"680d37f2","223":"78b42fa0","358":"2befd818","390":"7f14ac00","453":"5c7a3aed","474":"9d179008","494":"0cf1705f","503":"1e36c712","626":"f9dfab6b","631":"838d1278","790":"1a268bd6","795":"449ba484","824":"c581aba4","844":"30dc87f6","953":"733e2db2"}[chunkId] + ".chunk.js";
};